import React from 'react';
import PropTypes from 'prop-types';

import './Headers.scss';

const BASE = 'mb-reportSettledSelectionHeaders';

/**
 * These are the inner Headers that appear above the sections but below the market.
 * @param {string} type The report type we're looking at, either bets, offers or settled.
 */
const Headers = ({ type }) => {
  // Settled bets are default here
  let id = 'Bet ID';
  let time = 'Matched Time';
  let pnlPrimary = 'Net P&L';
  let pnlSecondary = 'Gross P&L';
  let commsPrimary = 'Comms';
  let commsSecondary = '\u00A0'; // was 'Rate' - to remove till the API is ready
  // FIXME: Add back in liability header when API returns it
  let liability = '\u00A0';
  // let liability = 'Liability';

  switch (type) {
    case 'bets':
      pnlPrimary = 'Liability';
      pnlSecondary = '\u00A0';
      commsPrimary = 'P. Profit';
      commsSecondary = '\u00A0';
      liability = '\u00A0';
      break;
    case 'offers':
      id = 'Offer ID';
      time = 'Submitted Time';
      pnlPrimary = 'Liability';
      pnlSecondary = '\u00A0';
      commsPrimary = 'P. Profit';
      commsSecondary = '\u00A0';
      liability = '\u00A0';
      break;
    case 'settled':
      // time = 'Settled Time';
      time = 'Matched Time';
      break;
    default:
  }

  return (<tr className={BASE}>
    <td />
    <td className={`${BASE}__selection`}>
      <span className={`${BASE}__headerPrimary`}>
        Selection
      </span>
      <span className={`${BASE}__headerSecondary`}>
        Side
      </span>
    </td>
    <td>
      <span className={`${BASE}__headerPrimary`}>
        {time}
      </span>
      <span className={`${BASE}__headerSecondary`}>
        {id}
      </span>
    </td>
    <td className={`${BASE}__odds`}>
      <span className={`${BASE}__headerPrimary`}>
        Odds
      </span>
    </td>
    <td className={`${BASE}__stake`}>
      <span className={`${BASE}__headerPrimary`}>
        Stake
      </span>
      <span className={`${BASE}__headerSecondary`}>
        {liability}
      </span>
    </td>
    <td className={`${BASE}__pnl`}>
      <span className={`${BASE}__headerPrimary`}>
        {pnlPrimary}
      </span>
      <span className={`${BASE}__headerSecondary`}>
        {pnlSecondary}
      </span>
    </td>
    <td className={`${BASE}__commissions`}>
      <span className={`${BASE}__headerPrimary`}>
        {commsPrimary}
      </span>
      <span className={`${BASE}__headerSecondary`}>
        {commsSecondary}
      </span>
    </td>
  </tr>);
};

Headers.propTypes = {
  type: PropTypes.oneOf(['bets', 'offers', 'settled']).isRequired
};

export default Headers;
